import * as React from 'react';
import { react2panel } from 'common/util/react2panel';
import { Trans } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { BannerReact } from 'common/components/banner';
import { BannerTheme, BannerType } from 'common/components/banner/types';
import { LoadingStatus } from '../types';
import { SharingModalState } from './types';
const PublicBoardBanner = (props: {
  showSuperadminBanner: boolean;
  publicDashboardLinks: SharingModalState[`publicDashboardLinks`];
  boardName: any;
}) => {
  const {
    t
  } = useTranslation();
  return <>
      {props.showSuperadminBanner ? <BannerReact style={{
      marginBottom: "20px"
    }} bodyText={t("components.sharing.boards.superadmin-access")} theme={BannerTheme.Info} type={BannerType.Embedded} /> : null}
      <p className='public-dashboard-disclaimer'>
        <Trans t={t} i18nKey={"components.sharing.boards.public-access"} components={{
        bold: <strong />,
        break: <br />
      }} data-sentry-element="Trans" data-sentry-source-file="public-board-banner.tsx" />
      </p>
      {props.publicDashboardLinks.loading === LoadingStatus.Success ? <div className='banner-wrapper'>
          <div className='color-indicator' />
          <p>
            <Trans t={t} i18nKey={"components.sharing.boards.public-links"} components={{
          bold: <strong />
        }} values={{
          boardName: props.boardName,
          count: props.publicDashboardLinks.data.length
        }} />
          </p>
        </div> : null}
    </>;
};
export const PublicBoardBannerEl = react2panel("mp-public-board-banner", PublicBoardBanner);